import React, {Component} from 'react';
import styles from "./prompt.module.css";
import closeIcon from "../../img/bt-close.png";
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';


class Prompt extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [

        ]);
        this.state = {
            inputVlue: "",

        }
    }



    render() {

        return (
            <div className={styles["modal-overlay"]}>
                <div className={styles["modal-content"]}>
                    <div className={styles.titlebar}>
                        <div className={styles["text-name"]}>
                            {this.props.label}
                        </div>

                        <img
                            className={styles.close}
                            src={closeIcon}
                             onClick={this.props.onCancel}
                        />
                    </div>

                    <div className={styles.body}>

                        <div className={styles.title}>{this.props.title}</div>

                        <div className={styles["button-row"]} >
                            <div className={styles["div-bt"]}>
                                <div
                                    className={styles.button}
                                    onClick={this.props.onCancel}
                                >
                                    取消
                                </div>
                                <div
                                    className={styles["ok-button"]}
                                    onClick={this.props.onOk}
                                >
                                    确定
                                </div>
                            </div>

                        </div>
                    </div>




                </div>



            </div>
        )
    }


}

Prompt.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Prompt);

